const handleScrollTo = () => {
	const scrollElements = document.querySelectorAll('[data-scroll]');

	scrollElements.forEach((el) => {
		el.addEventListener('click', (e) => {
			e.preventDefault();
			const targetId = el.getAttribute('href');
			const targetElement = document.querySelector(targetId);
			if (targetElement) {
				targetElement.scrollIntoView({ behavior: 'smooth' });
			}
		});
	});
};

export default handleScrollTo;
